/**
 * Typed access to Vite environment variables.
 * All env vars must be prefixed with VITE_ to be exposed to the browser.
 */
export const config = {
  apiUrl: import.meta.env.VITE_API_URL as string | undefined,
  stage: (import.meta.env.VITE_STAGE as string | undefined) ?? "local",
  appName: (import.meta.env.VITE_APP_NAME as string | undefined) ?? "AL Life Memory",
  isDev: import.meta.env.DEV,
  isProd: import.meta.env.PROD,
} as const;
